/**
 * Type guard to check if a value is a non-null object
 * @param input - The value to check
 * @returns True if the input is a non-null object
 */
export function isRecord(input: unknown): input is Record<string, unknown> {
  return typeof input === 'object' && input !== null;
}
